
import React from 'react';

import { useMutation } from 'react-query';
import { AITailorOpen, AITailorChoice } from 'services/activities';

import ActionButton from '@core/components/actionbutton/ActionButton';
import Modal from '@core/components/Modal/Modal';
import UseModal from 'hooks/use-modal';
import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';

import { Crown } from 'iconsax-react';
import CrownIcon from '@core/assets/icons/crown-bold.svg';

import classes from './AIResumeButton.module.scss';

const AIResumeButton = ({ activeJob }) => {
    const { show, showModal, destroyModal } = UseModal();

    const { mutate: openModal } = useMutation('ai-tailor-open', AITailorOpen);
    const { mutate: modalChoice } = useMutation('ai-tailor-choice', AITailorChoice);

    const handleButtonClick = () => {
        openModal({ job_id: activeJob });
        showModal();
    };

    const handleChoice = (interested) => {
        modalChoice({ job_id: activeJob, interested });
        destroyModal();
    };

    return (
        <>
            <ActionButton kind='secondary' onClick={handleButtonClick}>
                <div className='d-flex justify-content-center gap-2'>
                    <CrownIcon />
                    AI-Tailor My CV for This Job
                </div>

            </ActionButton>

            <Modal
                show={show}
                closeHandler={destroyModal}
                isGoPermium={true}
                header={false}
                type={MOBILE_SLIDE_UP}
            >
                <div className={classes['wrapper']}>
                    <CrownIcon />
                    <h3>Help Us Shape the Pharmuni AI Job board</h3>
                    <p>We’re testing a new premium feature for Pharmuni Jobs.</p>
                    <p>With this feature, subscribers could upload their CV once, choose a job, and use AI to customize their CV based on that job description.</p>
                    <p>This could help users apply faster and create more relevant applications.</p>
                    <p>Would you like us to build this feature?</p>
                    <div className='d-flex flex-column align-items-center mt-3' >
                        <ActionButton onClick={() => handleChoice(true)}>
                            Yes, keep me updated
                        </ActionButton>
                        <ActionButton onClick={() => handleChoice(false)} kind='blank'>
                            Not Now
                        </ActionButton>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default AIResumeButton;
